import { createContext, useContext, useState, useEffect, ReactNode } from "react";

export type ThemeMode = "dark"; // Enforced Dark Mode

interface ThemeContextType {
  theme: ThemeMode;
  setTheme: (theme: ThemeMode) => void;
}

const ThemeContext = createContext<ThemeContextType | undefined>(undefined);

export function ThemeProvider({ children }: { children: ReactNode }) {
  // Always initialize as dark
  const [theme] = useState<ThemeMode>("dark");

  useEffect(() => {
    const root = document.documentElement;
    // Clean up any old legacy classes
    root.classList.remove("pearly", "silk", "light");
    root.classList.add("dark");
  }, []);

  const setTheme = () => {
    // No-op: Theme is locked to dark
    console.log("Theme is locked to Dark Mode");
  };

  return (
    <ThemeContext.Provider value={{ theme, setTheme }}>
      {children}
    </ThemeContext.Provider>
  );
}

export function useTheme() {
  const context = useContext(ThemeContext);
  if (context === undefined) {
    throw new Error("useTheme must be used within a ThemeProvider");
  }
  return context;
}
